import WidgetModule from "@eisinc/Overrides/Widgets/Header/HeaderLinkList";

export * from "@eisinc/Overrides/Widgets/Header/HeaderLinkList";

export default WidgetModule;
